/** Shared visual treatment for public-page calls to action. */
const publicCtaBaseClasses =
  "inline-flex min-h-12 items-center justify-center gap-2 border px-6 py-3 font-mono text-sm font-bold uppercase tracking-[0.04em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary whitespace-nowrap";

export const PUBLIC_CTA_PRIMARY_CLASSES =
  `${publicCtaBaseClasses} border-transparent bg-primary text-primary-foreground hover:bg-primary-dark`;

export const PUBLIC_CTA_SECONDARY_CLASSES =
  `${publicCtaBaseClasses} border-canvas-border-mid bg-transparent text-canvas-fg hover:border-primary hover:text-primary`;
